import { BaseService } from './base.service';

export class ClientService extends BaseService {
    baseUrl = '/client';
}
